import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import MasterAPI from 'service/master';

const initialState = {
    authorizationProcess: false,
    authorization: false,
    accessToken: null,
    info: {
        fetched: false,
        error: false,
        user: {},
        shop: {}
    },
    messages: {
        fetched: false,
        error: false,
        data: {}
    }
}

export const refreshTokenAction = createAsyncThunk(
    'refreshTokenAction',
    async data => {
        const { refreshToken, reloadPage = false } = data;

        const res = await MasterAPI({
            url: "/api/user/refresh_token",
            sendAuthorizationHeader: false,
            data: {
                refresh_token: refreshToken
            }
        });

        if (res.access_token && res.refresh_token)
            return { result: res, reloadPage };
        else
            throw Object.assign(new Error("access token not exists"));
    }
)

export const fetchInfo = createAsyncThunk(
    'fetchInfo',
    async () => {
        try {
            const fetchUserInfo = await MasterAPI({
                method: "GET",
                url: "/api/user/get_profile"
            });

            if (fetchUserInfo.profile) {
                try {
                    const shopDataRes = await MasterAPI({
                        method: "GET",
                        url: "/api/profile/get",
                    });

                    return {
                        shop: shopDataRes.data,
                        user: fetchUserInfo.profile
                    }
                } catch (e) {
                    if (e.code === 1006) {
                        return {
                            shop: {},
                            user: fetchUserInfo.profile
                        }
                    } else
                        throw Object.assign(new Error("data error"));
                }
            } else
                throw Object.assign(new Error("data error"));
        } catch {
            throw Object.assign(new Error("data error"));
        }
    }
)

export const fetchMessages = createAsyncThunk(
    'fetchMessages',
    async () => {
        try {
            const res = await MasterAPI({
                method: "GET",
                url: "/api/message/list?seen=false&limit=3"
            });

            if (res.data)
                return res;
            else
                throw Object.assign(new Error("data error"));
        } catch {
            throw Object.assign(new Error("data error"));
        }
    }
)

export const mainSlice = createSlice({
    name: 'main',
    initialState,
    reducers: {
        overwriteState: (state, action) => {
            return {
                ...state,
                ...action.payload
            }
        },
        setMainState: (_, action) => {
            return action.payload;
        },
        setAccessToken: (state, action) => {
            const { accessToken, accessTokenExpireTime } = action.payload;

            return {
                ...state,
                authorizationProcess: true,
                authorization: true,
                accessToken,
                accessTokenExpireTime
            }
        },
        setAuthorizationProcess: (state, action) => {
            state.authorizationProcess = action.payload;
        },
        setUserInfo: (state, action) => {
            return {
                ...state,
                info: {
                    shop: { ...state.info.shop },
                    user: action.payload,
                    fetched: true,
                    errror: false
                }
            }
        },
        clearUser: state => {
            return {
                ...state,
                info: {
                    fetched: true,
                    shop: {},
                    user: {}
                }
            }
        },
        setEnableReloadAction: state => {
            state.enableReloadAction = true;
        }
    },
    extraReducers: (builder) => {
        // refresh token
        builder.addCase(refreshTokenAction.fulfilled, (state, action) => {
            const {
                result: {
                    access_token,
                    access_token_expire_in,
                    refresh_token,
                    refresh_token_expire_in
                },
                reloadPage
            } = action.payload;

            localStorage.setItem("_at", access_token);
            localStorage.setItem("_atet", access_token_expire_in);

            localStorage.setItem("_rt", refresh_token);
            localStorage.setItem("_rtet", refresh_token_expire_in);

            if (reloadPage)
                window.location.reload();

            return {
                ...state,
                authorizationProcess: true,
                authorization: true,
                accessToken: access_token,
                accessTokenExpireTime: access_token_expire_in
            }
        })

        builder.addCase(refreshTokenAction.rejected, state => {
            localStorage.removeItem("_at");
            localStorage.removeItem("_atet");
            localStorage.removeItem("_rt");
            localStorage.removeItem("_rtet");

            return {
                ...state,
                authorizationProcess: true,
                authorization: false,
                accessToken: null
            }
        })

        // user info
        builder.addCase(fetchInfo.fulfilled, (state, action) => {
            return {
                ...state,
                info: {
                    fetched: true,
                    ...action.payload
                }
            }
        })

        builder.addCase(fetchInfo.rejected, state => {
            return {
                ...state,
                info: {
                    fetched: true,
                    error: true,
                    user: {},
                    shop: {}
                }
            }
        })

        // messages
        builder.addCase(fetchMessages.fulfilled, (state, action) => {
            const { count, data } = action.payload;

            return {
                ...state,
                messages: {
                    fetched: true,
                    error: false,
                    data: {
                        count,
                        list: data
                    }
                }
            }
        })

        builder.addCase(fetchMessages.rejected, state => {
            return {
                ...state,
                messages: {
                    fetched: true,
                    error: true,
                    data: {}
                }
            }
        })
    }
})

export const {
    setAccessToken,
    setAuthorizationProcess,
    overwriteState,
    setMainState,
    clearUser,
    setUserInfo,
    setEnableReloadAction
} = mainSlice.actions

export default mainSlice.reducer;